var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('ProfileTitle',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h1',{staticClass:"main__title"},[_vm._v("Hello, "+_vm._s(_vm.generalInfo.first_name)+" "+_vm._s(_vm.generalInfo.last_name))])]},proxy:true}])}),_vm._v(" "),_c('TabContainer',{attrs:{"tabs":_vm.computedTabs,"space-between":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }